import React from "react";
import captchaImg from "../images/captchaImg.png";
import { LABELS } from "../utils";

const WhatIsCaptcha = ({
  width,
  breakpoint,
}) => {
  return (
    <div
      className={`${
        width > breakpoint ? "font16 lineHeight22" : "font14 lineHeight16"
      }`}
    >
      <p
        className={`needHelp__CaptchaDesc ${
          width > breakpoint ? "appendBottom25" : "appendBottom15"
        }`}
      >
        {LABELS.CAPTCHA_LINE_1 + ' ' + LABELS.CAPTCHA_LINE_2}
      </p>
      <div className="capchtaImgWrap">
        <img src={captchaImg} alt={LABELS.CAPTCHA} />
      </div>
      <p
        className={`${
          width > breakpoint ? "lightGreyText2" : "lightGreyText"
        }`}
      >
        {LABELS.CAPTCHA_LINE_3}
      </p>
    </div>
  )
};

export default WhatIsCaptcha;
